import React from 'react';
import { Box, IconButton } from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import SharedPageBackground from '../../../components/SharedPageBackground/SharedPageBackground';
import LanguageSwitcher from '../../../components/LanguageSwitcher';
import { useNotebookChat } from './useNotebookChat';
import ChatSidebar from './components/ChatSidebar';
import ChatMessages from './components/ChatMessages';
import ChatInputPanel from './components/ChatInputPanel';
import OutlineDialog from './components/OutlineDialog';

function NotebookChatPage() {
  const {
    notebookId,
    navigate,
    currentUser,
    isTeacher,
    notebookTitle,
    agentAvatar,
    conversations,
    currentConversationId,
    messages,
    inputMessage,
    setInputMessage,
    loadingHistory,
    loadingConversations,
    sending,
    streamingContent,
    sidebarCollapsed,
    setSidebarCollapsed,
    sidebarTab,
    setSidebarTab,
    chatWidthMode,
    setChatWidthMode,
    outlineDialogOpen,
    setOutlineDialogOpen,
    notebookData,
    generatedDescriptionForSave,
    savingDescription,
    messagesEndRef,
    handleSaveDescriptionToNotebook,
    handleNewChat,
    handleSelectConversation,
    handleDeleteConversation,
    handleGenerateDescription,
    handleStartReview,
    reviewLoading,
    selectingNextQuestion,
    reviewExerciseIndices,
    currentExerciseIndex,
    setCurrentExerciseIndex,
    handleExerciseAnswerSubmitted,
    handleSend,
    lastExercise,
    lastExerciseAnswerInInput,
    lastExerciseCode,
    codeEditorOpen,
    setCodeEditorOpen,
    formatDate,
  } = useNotebookChat();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh', position: 'relative', overflow: 'hidden' }}>
      <SharedPageBackground />
      <Box sx={{ position: 'relative', zIndex: 1, display: 'flex', flexDirection: 'column', height: '100%' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2, py: 1, flexShrink: 0 }}>
          <IconButton
            size="small"
            onClick={() => navigate('/notebooks')}
            sx={{ color: 'text.primary', '&:hover': { bgcolor: 'action.hover' } }}
            aria-label="返回"
          >
            <ArrowBackIcon />
          </IconButton>
          <LanguageSwitcher />
        </Box>
        <Box sx={{ flex: 1, display: 'flex', minHeight: 0, position: 'relative' }}>
          <ChatSidebar
            notebookTitle={notebookTitle}
            notebookId={notebookId}
            agentAvatar={agentAvatar}
            sidebarCollapsed={sidebarCollapsed}
            setSidebarCollapsed={setSidebarCollapsed}
            sidebarTab={sidebarTab}
            setSidebarTab={setSidebarTab}
            conversations={conversations}
            currentConversationId={currentConversationId}
            loadingConversations={loadingConversations}
            isTeacher={isTeacher}
            navigate={navigate}
            formatDate={formatDate}
            handleSelectConversation={handleSelectConversation}
            handleDeleteConversation={handleDeleteConversation}
            handleNewChat={handleNewChat}
            handleGenerateDescription={handleGenerateDescription}
            handleStartReview={handleStartReview}
            reviewLoading={reviewLoading}
            setOutlineDialogOpen={setOutlineDialogOpen}
          />
          <ChatMessages
            notebookTitle={notebookTitle}
            agentAvatar={agentAvatar}
            notebookId={notebookId}
            messages={messages}
            streamingContent={streamingContent}
            sending={sending}
            loadingHistory={loadingHistory}
            reviewLoading={reviewLoading}
            selectingNextQuestion={selectingNextQuestion}
            reviewExerciseIndices={reviewExerciseIndices}
            currentExerciseIndex={currentExerciseIndex}
            setCurrentExerciseIndex={setCurrentExerciseIndex}
            currentUser={currentUser}
            isTeacher={isTeacher}
            generatedDescriptionForSave={generatedDescriptionForSave}
            savingDescription={savingDescription}
            messagesEndRef={messagesEndRef}
            handleSaveDescriptionToNotebook={handleSaveDescriptionToNotebook}
            handleExerciseAnswerSubmitted={handleExerciseAnswerSubmitted}
            lastExercise={lastExercise}
            lastExerciseAnswerInInput={lastExerciseAnswerInInput}
            codeEditorOpen={codeEditorOpen}
            setCodeEditorOpen={setCodeEditorOpen}
          />
          <ChatInputPanel
            inputMessage={inputMessage}
            setInputMessage={setInputMessage}
            sending={sending}
            chatWidthMode={chatWidthMode}
            setChatWidthMode={setChatWidthMode}
            handleSend={handleSend}
            lastExerciseAnswerInInput={lastExerciseAnswerInInput}
            lastExerciseCode={lastExerciseCode}
            handleExerciseAnswerSubmitted={handleExerciseAnswerSubmitted}
            codeEditorOpen={codeEditorOpen}
            setCodeEditorOpen={setCodeEditorOpen}
          />
        </Box>
        <OutlineDialog
          open={outlineDialogOpen}
          onClose={() => setOutlineDialogOpen(false)}
          notebookData={notebookData}
        />
      </Box>
    </Box>
  );
}

export default NotebookChatPage;
